import React from "react";

import { IBasket, IBasketLine } from "../../../models/catalogue.interfaces";
import { LinePriceType, getBasketLinePrice } from "../../../utils/catalogue";
import { BasketLineOfferDetails } from "./BasketLineOfferDetails";
import { LinePrice } from "./LinePrice";

export const BasketLinePrice = (props: {
    line: IBasketLine;
    basket: IBasket;
    isMinimal: boolean;
}): React.ReactNode => (
    <LinePrice
        retailPrice={getBasketLinePrice(props.basket, props.line, {
            priceType: LinePriceType.RETAIL,
        })}
        linePriceInclDiscounts={getBasketLinePrice(props.basket, props.line, {
            priceType: LinePriceType.EXCL_TAX_INCL_DISCOUNTS,
        })}
        postDiscountAddons={props.line.product.price.post_discount_addons}
        quantity={props.line.quantity}
    >
        {!props.isMinimal && (
            <BasketLineOfferDetails line={props.line} basket={props.basket} />
        )}
    </LinePrice>
);
